import React from "react";
import { CircularProgress } from "@mui/material";
import { ErrorAlert } from "components/alert/ErrorAlert";
import { FormattedTextArea } from "components/form/FormattedTextArea";

type LicenseKeyXmlProps = {
  loading: boolean;
  licenseXml?: string;
  error?: Error;
};

export function LicenseKeyXmlView(props: LicenseKeyXmlProps) {
  const { loading, licenseXml, error } = props;

  return loading ? (
    <CircularProgress />
  ) : !error ? (
    <FormattedTextArea value={licenseXml ?? " "} language="xml" />
  ) : (
    <ErrorAlert error={error} />
  );
}
